import "./stats.css"
import 'react-notifications/lib/notifications.css'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import Chart from "react-apexcharts"
import { FaCalendarAlt, FaStore } from "react-icons/fa"
import AdminLayout from "../../../components/AdminLayout"

import AdminService from "../../../services/admin_services"

const monthAgo = new Date()
monthAgo.setMonth(monthAgo.getMonth() - 1)

class AdminStatBusiness extends Component {
    constructor(props) {
        super(props)
        this.state = {
            start_date: monthAgo.toISOString().substring(0, 10),
            end_date: new Date().toISOString().substring(0, 10),
            business_visit: {},
            daily: null,
            weekly: null,
            loading: true,
            error: null,
        }
    }

    componentDidMount = async () => {
        await this.loadStats()
    }

    loadStats = async () => {
        try {
            this.setState({ loading: true, error: null })
            const stats = await AdminService.getBusinessStats(this.state.start_date, this.state.end_date)
            const daily = stats.distributed_cards?.daily || {}
            const weekly = stats.distributed_cards?.weekly || {}
            const creation = stats.business_creation || {}
            const dailyViews = stats.daily_views || {}
            const weeklyViews = stats.weekly_views || {}
            const stacked = (id, data) => ({ chart: { id, stacked: true }, xaxis: { categories: Object.keys(data) } })
            const viewsSeries = (data) => [
                { name: "App", data: Object.values(data).map(v => v.app || 0) },
                { name: "Website", data: Object.values(data).map(v => v.website || 0) },
            ]
            this.setState({
                business_visit: stats.business_visit || {},
                creation: [
                    { name: "Referenced", data: Object.values(creation).map(v => v.referenced || 0) },
                    { name: "Registered", data: Object.values(creation).map(v => v.registered || 0) },
                ],
                creationOptions: stacked("business-creation", creation),
                dailyViews: viewsSeries(dailyViews),
                dailyViewsOptions: stacked("business-daily-views", dailyViews),
                weeklyViews: viewsSeries(weeklyViews),
                weeklyViewsOptions: stacked("business-weekly-views", weeklyViews),
                daily: [{ name: "Distributed cards", data: Object.values(daily) }],
                weekly: [{ name: "Distributed cards", data: Object.values(weekly) }],
                dailyOptions: { chart: { id: "business-daily" }, xaxis: { categories: Object.keys(daily) } },
                weeklyOptions: { chart: { id: "business-weekly" }, xaxis: { categories: Object.keys(weekly) } },
                loading: false,
            })
        } catch (error) {
            this.setState({
                loading: false,
                error: error.response?.data?.message || error.message,
            })
        }
    }

    renderMetric = (label, value, suffix = "") => (
        <div className="bg-white border border-gray-200 rounded-lg p-5 text-center">
            <p className="text-2xl font-bold text-gray-900">{(value || 0).toLocaleString()}{suffix}</p>
            <p className="text-xs font-semibold text-gray-500 uppercase mt-1">{label}</p>
        </div>
    )

    render() {
        const visit = this.state.business_visit
        return (
            <AdminLayout
                title="Business Statistics"
                breadcrumbs={[
                    { label: 'Statistics', href: '/admin/stats' },
                    { label: 'Business' }
                ]}
            >
                <div className="space-y-6">
                    <div className="bg-white shadow-md border border-gray-200 rounded-xl p-6">
                        <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-2">
                            <FaStore className="text-orange-600" /> Business Statistics
                        </h3>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            {['start_date', 'end_date'].map(field => (
                                <div key={field}>
                                    <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                                        <FaCalendarAlt className="text-gray-500" /> {field === 'start_date' ? 'Start Date' : 'End Date'}
                                    </label>
                                    <input
                                        type="date"
                                        value={this.state[field]}
                                        onChange={(event) => this.setState({ [field]: event.target.value }, this.loadStats)}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 outline-none"
                                    />
                                </div>
                            ))}
                        </div>
                    </div>

                    {this.state.error ? (
                        <div className="bg-red-50 border border-red-200 text-red-700 rounded-lg p-4">{this.state.error}</div>
                    ) : this.state.loading ? (
                        <div className="bg-white border border-gray-200 rounded-lg p-8 text-center text-gray-500">Loading statistics...</div>
                    ) : (
                        <>
                            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
                                {this.renderMetric('Scans', visit.nb_scan)}
                                {this.renderMetric('Unique businesses', visit.nb_unique_business)}
                                {this.renderMetric('Unique players', visit.nb_unique_player)}
                                {this.renderMetric('Active players visiting', visit.players_rate, '%')}
                            </div>
                            <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
                                <div className="bg-white shadow-md border border-gray-200 rounded-xl p-6">
                                    <h4 className="text-lg font-semibold text-gray-900 mb-4">Business Creation</h4>
                                    <Chart options={this.state.creationOptions} series={this.state.creation} type="bar" />
                                </div>
                                <div className="bg-white shadow-md border border-gray-200 rounded-xl p-6">
                                    <h4 className="text-lg font-semibold text-gray-900 mb-4">Daily Views</h4>
                                    <Chart options={this.state.dailyViewsOptions} series={this.state.dailyViews} type="bar" />
                                </div>
                                <div className="bg-white shadow-md border border-gray-200 rounded-xl p-6">
                                    <h4 className="text-lg font-semibold text-gray-900 mb-4">Weekly Views</h4>
                                    <Chart options={this.state.weeklyViewsOptions} series={this.state.weeklyViews} type="bar" />
                                </div>
                            </div>
                            <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
                                <div className="bg-white shadow-md border border-gray-200 rounded-xl p-6">
                                    <h4 className="text-lg font-semibold text-gray-900 mb-4">Daily Card Distributions</h4>
                                    <Chart options={this.state.dailyOptions} series={this.state.daily} type="bar" />
                                </div>
                                <div className="bg-white shadow-md border border-gray-200 rounded-xl p-6">
                                    <h4 className="text-lg font-semibold text-gray-900 mb-4">Weekly Card Distributions</h4>
                                    <Chart options={this.state.weeklyOptions} series={this.state.weekly} type="bar" />
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </AdminLayout>
        )
    }
}

export default withTranslation()(AdminStatBusiness)